/* tslint:disable */
/* eslint-disable */
/**
 * Kapybro Frontend Api Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: hello@roguepaws.dev
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AutoCloseConfig,
    AutoCloseConfigFromJSON,
    AutoCloseConfigFromJSONTyped,
    AutoCloseConfigToJSON,
    FeedbackMessages,
    FeedbackMessagesFromJSON,
    FeedbackMessagesFromJSONTyped,
    FeedbackMessagesToJSON,
    FeedbackStateLabels,
    FeedbackStateLabelsFromJSON,
    FeedbackStateLabelsFromJSONTyped,
    FeedbackStateLabelsToJSON,
} from './';

/**
 * 
 * @export
 * @interface FeedbackManagementConfig
 */
export interface FeedbackManagementConfig {
    /**
     * 
     * @type {boolean}
     * @memberof FeedbackManagementConfig
     */
    enabled: boolean;
    /**
     * 
     * @type {FeedbackStateLabels}
     * @memberof FeedbackManagementConfig
     */
    labels?: FeedbackStateLabels;
    /**
     * 
     * @type {boolean}
     * @memberof FeedbackManagementConfig
     */
    assignAuthor?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FeedbackManagementConfig
     */
    assignMaintainers?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FeedbackManagementConfig
     */
    onlyAuthorReplies?: boolean;
    /**
     * 
     * @type {AutoCloseConfig}
     * @memberof FeedbackManagementConfig
     */
    autoClose?: AutoCloseConfig;
    /**
     * 
     * @type {FeedbackMessages}
     * @memberof FeedbackManagementConfig
     */
    messages?: FeedbackMessages;
}

export function FeedbackManagementConfigFromJSON(json: any): FeedbackManagementConfig {
    return FeedbackManagementConfigFromJSONTyped(json, false);
}

export function FeedbackManagementConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): FeedbackManagementConfig {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'enabled': json['enabled'],
        'labels': !exists(json, 'labels') ? undefined : FeedbackStateLabelsFromJSON(json['labels']),
        'assignAuthor': !exists(json, 'assignAuthor') ? undefined : json['assignAuthor'],
        'assignMaintainers': !exists(json, 'assignMaintainers') ? undefined : json['assignMaintainers'],
        'onlyAuthorReplies': !exists(json, 'onlyAuthorReplies') ? undefined : json['onlyAuthorReplies'],
        'autoClose': !exists(json, 'autoClose') ? undefined : AutoCloseConfigFromJSON(json['autoClose']),
        'messages': !exists(json, 'messages') ? undefined : FeedbackMessagesFromJSON(json['messages']),
    };
}

export function FeedbackManagementConfigToJSON(value?: FeedbackManagementConfig | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'enabled': value.enabled,
        'labels': FeedbackStateLabelsToJSON(value.labels),
        'assignAuthor': value.assignAuthor,
        'assignMaintainers': value.assignMaintainers,
        'onlyAuthorReplies': value.onlyAuthorReplies,
        'autoClose': AutoCloseConfigToJSON(value.autoClose),
        'messages': FeedbackMessagesToJSON(value.messages),
    };
}

